module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn1",
    attrs: {
      "id": "fm"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062258236_Contents#rfm"
    }
  }, [_vm._v("August 21, 1979")])]), _vm._v(" "), _c('p', {
    staticClass: "letter_f_l"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('i', [_vm._v("Dearest Anton,")])])]), _vm._v(" "), _c('p', {
    staticClass: "letter_f"
  }, [_c('i', [_vm._v("I hope you’re sleeping better and finding the food more to your liking, though I must say I envy the choices you have, corn mush or fufu or roasted snake. I picture you in one of those grass and bamboo huts, sleeping under your mosquito netting, reading by a kerosene lamp. Remember you’ll never again have an experience quite like this, and most great men begin great lives by getting out of their comfort zone. I’m glad you liked the books I sent, and yes I agree about the Alan Moorehead. It’s an old-fashioned sort of book, but there are sections of it that are as good as anything and it’ll be good for you to have read it.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("Your brother is doing pretty well, though he misses you terribly. He’s getting up early to do push-ups and sit-ups. He’s playing in a few local tournaments this summer, and is slowly mastering the psychological game. No more racket throwing. He’s been working with the Zen master tennis coach I told you about, and cleared out the negativity. It’s inspiring to witness.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("For myself I’m still—yes")]), _vm._v(" still"), _c('i', [_vm._v("—trying to find my balance, and more and more each day I am. My travels have done wonders for")]), _vm._v(" "), _c('i', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  })]), _c('i', [_vm._v("my spirit and my mind, not to mention my middle-aged body,")]), _vm._v(" "), _c('i', [_vm._v("which is more toned than it’s been since you were a young kid. And still I feel at times like I’m walking unsteadily. I miss the routine of the show, and am at the same time happy for all the hours in the day I have now to do other things. Sometimes I imagine us having conversations about our experiences and the people we meet. In a sense we’ve done this (albeit erratically) through letters, though I can’t wait to see you in person. We all can’t wait. Your mother keeps planning your meals and which")]), _vm._v(" "), _c('i', [_vm._v("movies she wants to take you to. Kip wants to kick your heinie on the tennis court and Rachel wants to take you riding in the park, like you used to.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("Everyone has his or her theory about what I’ve been through.")]), _vm._v(" "), _c('i', [_vm._v("Nice that they have such a broad term, isn’t it—nervous")]), _vm._v(" "), _c('i', [_vm._v("breakdown. Covers a lot of things. It feels to me like a fever I’ve broken through, and now I’m out of bed with the salt on my skin and the wind in my hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("Oh incidentally, I saw John L. in the elevator a month ago with Sean. I’d told him about your travels and filled him in with a few juicy details, and now he asks about you regularly. I told him of your digestive problems—maybe I exaggerated them a bit, but he had a similar story to tell. We walked all the way to the zoo. His boy is adorable.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("As for work, I’ve got some stand-up lined up, and I’m a bit anxious about it. We might even think about sneaking in a pricey phone call somehow so I can go over material.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("I won’t burden you with more and, really, Anton, I’m in good shape. The best physical shape I’ve been in in a long time. I’m swimming again. Playing tennis, as you know four times a week. Joblessness is great for your ground strokes.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("So be good, be alert. Eyes, ears and mind wide open. Eat a roasted snake for your old man. I love the story about all the")]), _vm._v(" "), _c('i', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  })])]), _c('i', [_vm._v("village kids surrounding you wanting your autograph, and not knowing at all who you were, only that you were from America.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("Cherish how far away you are. What an adventure!")])]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_c('i', [_vm._v("Talk to you soon.")])]), _vm._v(" "), _c('p', {
    staticClass: "letter_clos"
  }, [_c('i', [_vm._v("Love,")])]), _vm._v(" "), _c('p', {
    staticClass: "letter_clos"
  }, [_c('i', [_vm._v("Buddy (aka Dad)")])]), _vm._v(" "), _c('p', {
    staticClass: "letter_clos"
  }, [_c('i', [_vm._v("PS. The Mets are stinking it up, sadly.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39c3f475","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062258236_Frontmatter.vue
// module id = 72
// module chunks = 0